import SySlide from "./sy-slide";

export default SySlide;
